import React from 'react';
import ModalCloseButton from '../Common/ModalCloseButton';

const InfoModal = ({ show, selectedPackage, onClose }) => {
  if (!show || !selectedPackage) return null;

  return (
    <div className="info-modal">
      <div className="modal-content">
        <ModalCloseButton onClick={onClose} />
        <h3>{selectedPackage.title}</h3>
        <p className="modal-description">{selectedPackage.description}</p>
      </div>
    </div>
  );
};

export default InfoModal;
